<div class="po-row" style="padding-top: 1em; padding-bottom: 1em;">
  <p class="taskTitle npl po-xl-1 po-lg-1 po-md-1 po-sm-1" style="width: 5%">{{ literalsCp?.strTarefas | uppercase }}</p>
  <hr class="po-xl-11 po-lg-11 po-md-11 po-sm-11" style="margin-top: 30px; width: 95%" />
</div>

<cp-inputdisclaimergroup #inputDisclaimerGroup
(resultDisclaimers)="GetFiltersTask($event)"
[placeholder]="placeholderTaskInput"
icon="po-icon-edit">
</cp-inputdisclaimergroup>

<div style="position:relative">
  <div *ngIf="inputTasks && inputTasks.items.length > 0; else NenhumaTarefa">
    <div *ngFor="let item of itemsTasks" class="po-row">
      <div class="po-row" style="margin-top: 2em;">
        <div class="circuloSucesso po-xl-1 po-lg-1 po-md-1 po-sm-1">
          <span class="po-icon po-icon-construction iconMiddle"></span>
        </div>
        <p class="taskDescripton po-xl-10 po-lg-10 po-md-10 po-sm-10">{{ item.taskDescription != '' && item.taskDescription ? item.taskDescription : item.taskName}}</p>
      </div>

      <div class="po-row">
        <p class="taskCod np po-xl-12 po-lg-12 po-md-12 po-sm-12">{{ literalsCp?.strCod | uppercase }} {{ item.taskCode}}</p>
      </div>

      <cp-taskcharts [taskitem]="item" [hiddenCharts]="true" style="margin-top: 1em;"></cp-taskcharts>
    </div>

    <div style="position: relative">
      <cp-loading-button  [hasNext]="this.inputTasks.hasNext" (click)="load()"></cp-loading-button>
      <po-loading-overlay [hidden]="isHideLoadingVejaMais"></po-loading-overlay>
    </div>
  </div>

  <po-loading-overlay [hidden]="isHideLoading"></po-loading-overlay>
</div>

<ng-template #NenhumaTarefa>
  <p style="margin-top: 2em;">{{ literalsCp?.strNenhumRegistroEncontrado }}</p>
</ng-template>
